import { ArrowForwardIos } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  Grid,
  Paper,
  TextField,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  fValidationHead_Client,
  fWmsStockRepotArr,
  fWmsStockRepotBrandArr,
  GetLocation,
  GetWmsStockRepotBrand,
  GetWmsStockRepotMainSupplier,
  HeadObjectInit,
  sWebStockReportData,
} from "./Action";
import HeaderComponent from "./HeaderComponent";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import { ItemMSP_Api, ItemMSP_Save_Api } from "../../Server/ApiV2";
import IntegerEditCell from "./IntergerEditCell";
import { fAlertToast } from "../../Utility/Utilitys";
import { vRdxUserInfo } from "../../Redux/roStore";
import { useSelector } from "react-redux";

const ItemMSP = () => {
  const locationArr = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const [sLocationData, setLocationData] = useState([]);
  const [sMainGroupData, setMainGroupData] = useState([]);
  const [sSubGroupData, setSubGroupData] = useState([]);
  const [sCategoryData, setCategoryData] = useState([]);
  const [sBrandData, setBrandData] = useState([]);
  const [sBrandCategoryData, setBrandCategoryData] = useState([]);
  const [sMainSupplierData, setMainSupplierData] = useState([]);
  const [summaryRows, setSummaryRows] = useState([]);
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);
  const [validateOnLoad, setValidateOnLoad] = useState(false);

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
      sAisle: "All",
      sAisleCode: "",
      sAisleName: "",
      sBin: "All",
      sBinFromCode: "",
      sBinFromName: "",
    }));
  };
  const fLocation_MultiSelect = async (newValue) => {
    let currentPrnt = newValue.map((option) => option.Uid).join(",");
    let currentName = newValue.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: newValue,
      sLocationPrnt: newValue.length > 0 ? currentPrnt : "",
      sLocationName: newValue.length > 0 ? currentName : "",
    }));
  };

  const fMainGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sMainGroup: e.target.value,
      sMainGroupArr: [],
      sMainGroupPrnt: "",
      sMainGroupName: "",
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);

    if (e.target.value.toUpperCase() == "ALL") {
      setMainGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj = {
        Prnt: "",
        Lvl: "1",
      };
      await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
    }
  };

  const fMainGroup_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");

    setHeadObject((obj) => ({
      ...obj,
      sMainGroupArr: value,
      sMainGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sMainGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fMainGroup_Focus();
  };
  const fMainGroup_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setSubGroupData([]);
    setCategoryData([]);
  };

  const fSubGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    setCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setSubGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj2 = {
        Prnt: HeadObject.sMainGroupPrnt,
        Lvl: "2",
      };
      await fWmsStockRepotArr(xGroupStructureObj2, setSubGroupData);
    }
  };

  const fSubGroup_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sSubGroupArr: value,
      sSubGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sSubGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fSubGroup_Focus();
  };

  const fSubGroup_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sCategory: "All",
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));
    setCategoryData([]);
  };

  const fCategory = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCategoryArr: [],
      sCategoryPrnt: "",
      sCategoryName: "",
    }));

    if (e.target.value.toUpperCase() == "ALL") {
      setCategoryData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj2 = {
        Prnt: HeadObject.sSubGroupPrnt,
        Lvl: "3",
      };

      await fWmsStockRepotArr(xGroupStructureObj2, setCategoryData);
    }
  };

  const fCategory_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sCategoryArr: value,
      sCategoryPrnt: value?.length <= 0 ? "" : currentPrnt,
      sCategoryName: value?.length <= 0 ? "" : currentName,
    }));
    fCategory_Focus();
  };
  const fCategory_Focus = (value) => {};

  const fBrand = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sBrandArr: [],
      sBrandPrnt: "",
      sBrandName: "",
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
    setBrandCategoryData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setBrandData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotBrand(setBrandData);
    }
  };

  const fBrand_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sBrandCategoryArr: [],
      sBrandCategoryPrnt: "",
      sBrandCategoryCode: "",
      sBrandCategoryName: "",
    }));
  };

  const fMainSupplier = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sMainSupplierArr: [],
      sMainSupplierPrnt: "",
      sMainSupplierName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setMainSupplierData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotMainSupplier(setMainSupplierData);
    }
  };

  const suplGrpData =
    HeadObject?.sMainSupplierArr?.map((x) => x.AcCd).join(",") || "";

  const brandGrpData = HeadObject?.sBrandArr?.map((x) => x.UID).join(",") || "";

  const onLoad = async () => {
    setValidateOnLoad(true);

    const isValid = fValidationHead_Client(HeadObject, validateOnLoad);
    if (!isValid) return;

    const payload = {
      v_Loc: HeadObject.sLocationPrnt,
      v_MainGrp: HeadObject.sMainGroupPrnt ? HeadObject.sMainGroupPrnt : "ALL",
      v_SubGrp: HeadObject.sSubGroupPrnt ? HeadObject.sSubGroupPrnt : "ALL",
      v_Grp: HeadObject.sCategoryPrnt ? HeadObject.sCategoryPrnt : "ALL",
      v_BrandCd: brandGrpData !== "" ? brandGrpData : "ALL",
      v_Supplier: suplGrpData !== "" ? suplGrpData : "ALL",

      //  v_Loc: '04',
      // v_MainGrp: '10',
      // v_SubGrp: '10002',
      // v_Grp: '10002010',
      // v_BrandCd:  'X0915',
      // v_Supplier:  'C/00433',
    };

    const Result = await ItemMSP_Api(payload);
    console.log(Result, "fghj");

    if (Result?.status === 200) {
      setSummaryRows(Result?.data?.ResultSet);
    }
  };

  const fSave = async () => {
    const updatedItems = summaryRows
      .filter((r) => r.isChecked)
      .map((r) => ({
        ItmCd: r.ItmCd,
        Loc: r.Loc,
        Unit: r.Unit,
        RSP: Number(r.RSP) || 0,
        CostPr: Number(r.CostPr) || 0,
        GPPerc: Number(r.GPPerc) || 0,
        MSP: Number(r.MSP) || 0,
        MSPPerc: Number(r.MSPPerc) || 0,
      }));

    if (updatedItems.length === 0) {
      fAlertToast(
        "FAILED",
        "No changes detected. Please edit at least one row before saving."
      );
      return;
    }

    const user = vRdxUserInfo();
    const payload = {
      UserId: user?.UserID,
      IP: user?.IP ?? "0.0.0.0",
      Items: updatedItems,
    };

    // const finalObj = fcheck_null_undefine_replace_empty(payload);

    try {
      const resp = await ItemMSP_Save_Api(payload);

      if (resp?.status === 200) {
        fAlertToast("SUCCESS", "Items MSP/RSP updated successfully!");
      }
    } catch (err) {
      console.error(err);
      fAlertToast("FAILED", "Something went wrong! Please try again.");
    }
  };

  const fClear = () => {
    setHeadObject(HeadObjectInit);

    setSummaryRows((prev) =>
      prev.map((row) => ({
        ...row,
        RSP: 0,
        RSPVAT: 0,
        MSP: 0,
        isChecked: false, // uncheck all rows
      }))
    );
  };

  const Check = (row) => {
    return Number(row.RSP) > 0 || Number(row.RSPVAT) > 0 || Number(row.MSP) > 0;
  };

  // const handleBulkRSPApply = (value) => {
  //   summaryRows.forEach((row) => {
  //     handleRSPChange(row.RowId, value);
  //   });
  // };

  // const handleBulkRSPVATApply = (value) => {
  //   summaryRows.forEach((row) => {
  //     handleRSPVATChange(row.RowId, value);
  //   });
  // };

  // const handleBulkMSPApply = (value) => {
  //   summaryRows.forEach((row) => {
  //     handleMSPChange(row.RowId, value);
  //   });
  // };

  const handleRSPChange = (id, newValue) => {
    setSummaryRows((prev) =>
      prev.map((row) => {
        if (row.RowId !== id) return row;

        const rspValue = Number(newValue) || 0;

        const taxAmount = (row.TaxPerc / 100) * rspValue;
        const VatRSPValue = rspValue + taxAmount + row.AddiCessAmt;

        const gpPerc =
          rspValue === 0
            ? 0
            : Number(((rspValue - row.CostPr) / rspValue) * 100).toFixed(2);

        const updatedRow = {
          ...row,
          RSP: rspValue,
          RSPVAT: VatRSPValue.toFixed(2),
          GPPerc: gpPerc,
        };

        updatedRow.isChecked = Check(updatedRow);

        return updatedRow;
      })
    );
  };

  const handleRSPVATChange = (id, newValue) => {
    setSummaryRows((prev) =>
      prev.map((row) => {
        if (row.RowId !== id) return row;

        const rspVatValue = Number(newValue) || 0;

        const rspVAT1 = rspVatValue - row.AddiCessAmt;
        const vatRSp = (rspVAT1 / (100 + row.TaxPerc)) * 100;

        const gpPerc =
          vatRSp === 0
            ? 0
            : Number(((vatRSp - row.CostPr) / vatRSp) * 100).toFixed(2);

        // Build updated row
        const updatedRow = {
          ...row,
          RSP: vatRSp.toFixed(4),
          RSPVAT: rspVatValue,
          GPPerc: gpPerc,
        };

        // ✔ Apply checkbox auto-check/uncheck
        updatedRow.isChecked = Check(updatedRow);

        return updatedRow;
      })
    );
  };

  const handleMSPChange = (id, newValue) => {
    setSummaryRows((prev) =>
      prev.map((row) => {
        if (row.RowId !== id) return row;

        const mspValue = Number(newValue) || 0;

        const updatedRow = {
          ...row,
          MSP: mspValue,
          MSPPerc:
            mspValue === 0
              ? 0
              : Number(((mspValue - row.CostPr) / mspValue) * 100).toFixed(2),
        };

        // ALWAYS check/uncheck
        updatedRow.isChecked = Check(updatedRow);

        return updatedRow;
      })
    );
  };

  const fLoad = async () => {
    await GetLocation(setLocationData);
  };

  console.log(sLocationData);

  useEffect(() => {
    fLoad();
    onLoad();
  }, []);

  const columns = [
    {
      field: "select",
      headerName: "",
      width: 40,
      sortable: false,
      renderCell: (params) => (
        <Checkbox
          checked={params.row?.isChecked || false}
          onChange={(e) => {
            setSummaryRows((prev) =>
              prev.map((row) =>
                row.RowId === params.row.RowId
                  ? { ...row, isChecked: e.target.checked }
                  : row
              )
            );
          }}
        />
      ),
    },
    { field: "RowId", headerName: "ID", width: 140, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 140 },
    { field: "ItmName", headerName: "Item", width: 140 },
    { field: "Unit", headerName: "Unit", width: 80 },
    { field: "PackQty", headerName: "Pack.Qty", width: 100, align: "center" },
    {
      field: "CostPr",
      headerName: "Cost",
      width: 100,
      align: "right",
      valueFormatter: (params) => {
        if (params.value == null) return "";
        return Number(params.value).toFixed(2);
      },
    },

    // Editable columns using IntegerEditCell
    {
      field: "RSP",
      headerName: "RSP",
      width: 100,
      renderCell: (params) => {
        const rawValue = params.row.RSP ?? 0;

        return (
          <IntegerEditCell
            value={Number(rawValue).toFixed(2)} // Display 2 decimals
            onValueChange={
              (v) => handleRSPChange(params.row.RowId, Number(v)) // Send number
            }
          />
        );
      },
    },
    {
      field: "RSPVAT",
      headerName: "RSP.VAT",
      width: 110,
      renderCell: (params) => (
        <IntegerEditCell
          value={params.row.RSPVAT}
          onValueChange={(v) => handleRSPVATChange(params.row.RowId, v)}
        />
      ),
    },
    {
      field: "MSP",
      headerName: "MSP",
      width: 100,
      renderCell: (params) => (
        <IntegerEditCell
          value={params.row.MSP}
          onValueChange={(v) => handleMSPChange(params.row.RowId, v)}
        />
      ),
    },

    {
      field: "GPPerc",
      headerName: "GP%",
      width: 100,
      align: "right",
      valueGetter: (params) => params.row.GPPerc,
    },
    {
      field: "MSPPerc",
      headerName: "MSP%",
      width: 100,
      align: "right",
      valueGetter: (params) => params.row.MSPPerc,
    },
  ];

  const breadCrumbStyle = {
    color: "#cccccc",
    fontSize: "0.9rem",
    textDecoration: "underline",
  };

  const breadCrumbActiveStyle = {
    color: "#0288d1",
    fontSize: "0.9rem",
    textDecoration: "underline",
  };
  return (
    <Box p={2}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ mb: 1 }}>
          <span style={breadCrumbStyle}>Masters </span>{" "}
          <ArrowForwardIos color="info" style={{ marginRight: "0.5rem" }} />
          <span style={breadCrumbActiveStyle}>Items MSP</span>
        </Box>
      </Box>

      <HeaderComponent
        HeadObject={HeadObject}
        setHeadObject={setHeadObject}
        fLocation_MultiSelect={fLocation_MultiSelect}
        fLocation={fLocation}
        sWebStockReportData={sWebStockReportData}
        sLocationData={locationArr}
        sMainGroupData={sMainGroupData}
        sSubGroupData={sSubGroupData}
        fMainGroup={fMainGroup}
        fMainGroup_MultiSelect={fMainGroup_MultiSelect}
        fSubGroup={fSubGroup}
        fSubGroup_MultiSelect={fSubGroup_MultiSelect}
        fCategory={fCategory}
        sCategoryData={sCategoryData}
        fCategory_MultiSelect={fCategory_MultiSelect}
        fMainSupplier={fMainSupplier}
        fBrand={fBrand}
        onLoad={onLoad}
        fSave={fSave}
        fClear={fClear}
        summaryRows={summaryRows}
      />
      <Box
        sx={{
          height: { xs: "50vh", sm: "50vh", md: "60vh" },
        }}
      >
        {/* <Box sx={{ p: 1, mb: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="RSP"
                type="number"
                fullWidth
                size="small"
                value={bulkRSP}
                onChange={(e) => {
                  const value = e.target.value;
                  setBulkRSP(value);

                  // 🟩 Apply RSP to all rows
                  handleBulkRSPApply(value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label="RSP.VAT"
                type="number"
                fullWidth
                size="small"
                value={bulkVAT}
                onChange={(e) => {
                  const value = e.target.value;
                  setBulkVAT(value);

                  handleBulkRSPVATApply(value);
                }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <TextField
                label=" MSP"
                type="number"
                fullWidth
                size="small"
                value={bulkMSP}
                onChange={(e) => {
                  const value = e.target.value;
                  setBulkMSP(value);

                  // 🟩 Apply RSP to all rows
                  handleBulkMSPApply(value);
                }}
              />
            </Grid>
          </Grid>
        </Box> */}

        <DataGridPro
          rowHeight={30}
          headerHeight={40}
          rows={summaryRows ?? []}
          columns={columns}
          getRowId={(row) => row?.RowId}
          hideFooter
          sx={{
            width: "100%",
            height: "100%",
            border: 1,
            borderColor: "primary.light",

            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
            "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-pinnedColumnHeaders":
              {
                backgroundColor: "#0d73bb",
                color: "#fff",
              },
            "& .MuiDataGrid-pinnedColumnHeaders": {
              zIndex: 2,
              textAlign: "left",
            },
            "& .MuiDataGrid-pinnedColumns--left": {
              boxShadow: "4px 0 6px -4px rgba(37, 15, 15, 0.2)",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default ItemMSP;
